export default [
    {
        "error_id": "FSTR-01",
        "data": [
            {
                "cross_section": "42157",
                "profiles": [
                    "100yr (1%)",
                    "FW"
                ]
            },
            {
                "cross_section": "37890",
                "profiles": [
                    "100yr (1%)",
                    "FW"
                ]
            }
        ]
    }
]